// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vue-lazy-youtube-video/dist/style.css'
import Vue from 'vue'
import LazyYoutubeVideo from 'vue-lazy-youtube-video/dist/vue-lazy-youtube-video.min'
import ChooseCountry from './components/ChooseCountry'
import Header from './components/Header'
import Hero from './components/Hero'
import HeroUber from './components/HeroUber'
import Faq from './components/Faq'
import ProductSlider from './components/ProductSlider'
import Testimonials from './components/Testimonials'
import Partners from './components/Partners'
import Footer from './components/Footer'
import HelpVideoModal from './components/HelpVideoModal'
import App from './App'
import AppUber from './AppUber'
import AbacoPartnerUber from './components/AbacoPartnerUber'
import router from './router/index'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import CookieLaw from 'vue-cookie-law'
import Flag from './components/AbacoFlag'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(CookieLaw)

Vue.component('LazyYoutubeVideo', LazyYoutubeVideo)
Vue.component('abaco-choose-country', ChooseCountry)
Vue.component('abaco-flag', Flag)
Vue.component('abaco-header', Header)
Vue.component('abaco-hero', Hero)
Vue.component('abaco-faq', Faq)
Vue.component('abaco-product-slider', ProductSlider)
Vue.component('abaco-testimonials', Testimonials)
Vue.component('abaco-partners', Partners)
Vue.component('abaco-footer', Footer)
Vue.component('abaco-help-video-modal', HelpVideoModal)
Vue.component('abaco-hero-uber', HeroUber)
Vue.component('abaco-partner-uber', AbacoPartnerUber)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: { App, AppUber, Header }
})



// WEBPACK FOOTER //
// ./src/main.js